import { useCallback, useRef, useState } from 'react';
import useDebouncedCallback from './use-debounced-callback';
import useIsMounted from './use-is-mounted';
const initialFetchState = {
    loading: false,
    predictions: []
};
const usePlacesAutocomplete = ({ atlas, onError })=>{
    const debounceMs = 200;
    const [{ loading, predictions }, setFetchState] = useState(initialFetchState);
    const predictionsRequestId = useRef(0); // id of latest request to avoid race conditions
    const isMounted = useIsMounted(); // checks whether component is still mounted
    const clearPredictions = useCallback(()=>{
        // Increase request id counter
        predictionsRequestId.current++;
        setFetchState(initialFetchState);
    }, []);
    const updatePredictions = useDebouncedCallback(async ({ input, countryCodes })=>{
        if (!atlas) {
            return;
        }
        if (!isMounted()) {
            return;
        }
        if (!input) {
            clearPredictions();
            return;
        }
        // Increase request id counter
        const requestId = ++predictionsRequestId.current;
        setFetchState((state)=>({
                ...state,
                loading: true
            }));
        let newPredictions;
        try {
            newPredictions = await atlas.predict({
                input,
                countryCodes
            });
        } catch (error) {
            // failed to fetch predictions
            if (onError) {
                onError(error);
            } else {
                console.error(error);
            }
        } finally{
            // check if no new fetch request has been initiated
            const isMostRecentRequest = requestId === predictionsRequestId.current;
            if (isMounted() && isMostRecentRequest) {
                setFetchState((state)=>({
                        loading: false,
                        // set new predictions if fetched properly, else keep current predictions
                        predictions: newPredictions || state.predictions
                    }));
            }
        }
    }, [
        atlas,
        onError
    ], debounceMs);
    return {
        predictions,
        loading,
        updatePredictions,
        clearPredictions
    };
};
export default usePlacesAutocomplete;

//# sourceMappingURL=use-places-autocomplete.js.map